import React from "react";
import Modal from "../../../../../../components/ui/Modal/Modal";
import { useSetState } from "../../../../../../utils/hooks";
import InventoryIntegration from "./Instruction";
import { LotDataTable } from "./lot-data-table";

const DataModal = (props) => {
  const {
    data,
    productData,
    prodId,
    setTriggerCloseDataModal,
    setTriggerCloseDataModalInstruction,
    triggerCloseDataModalInstruction,
  } = props;
  const [lotFilter, dispatchFilter] = useSetState();
  const onCloseDataModal = () => {
    setTriggerCloseDataModal(true);
  };
  const onCloseDataModalInstruction = () => {
    setTriggerCloseDataModalInstruction(true);
  };
  return (
    <div>
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">LOT 재고 연동</h1>
        <div className="flex">
          <p className="flex items-center mr-5">
            ※ 스마트팩토리 재고 연동은 재고관리의 '스마트팩토리 재고 업데이트
            확인'에서 해주세요.
          </p>

          <Modal
            maxWidth="max-w-[27rem]"
            hasCancel={false}
            hasSubmit={false}
            description={
              <div className=" py-1 w-[26rem]">
                <div className="flex px-4 justify-end">
                  <button
                    onClick={onCloseDataModalInstruction}
                    className="border w-16 py-0.5 rounded-[4px]"
                  >
                    닫기
                  </button>
                </div>
                <div className="px-4 pb-2">
                  <InventoryIntegration />
                </div>
              </div>
            }
            triggerClose={triggerCloseDataModalInstruction}
          >
            <button className="border mr-2 px-6 py-1 border-button-grey rounded-[4px]">
              사용 안내
            </button>
          </Modal>
          <button
            onClick={onCloseDataModal}
            className="border mr-5 px-6 py-1 border-button-grey rounded-[4px]"
          >
            닫기
          </button>
        </div>
      </div>
      <div className="flex mt-4 px-5">
        <div
          className={`border border-primary-grey cursor-pointer text-title-grey w-56 border-r-0 text-center py-2.5 ${
            !lotFilter?.type && "bg-primary-blue text-white"
          }`}
          onClick={() => dispatchFilter({ type: "" })}
        >
          전체 재고 현황 확인
        </div>
        <div
          className={`border border-primary-grey cursor-pointer w-56 border-r-0 text-title-grey text-center py-2.5 ${
            lotFilter?.type === "SMART" && "bg-primary-blue text-white"
          }`}
          onClick={() => dispatchFilter({ type: "SMART" })}
        >
          스마트팩토리 연동
        </div>
        <div
          className={`border border-primary-grey w-56 cursor-pointer text-title-grey text-center py-2.5 ${
            lotFilter?.type === "MANUAL" && "bg-primary-blue text-white"
          }`}
          onClick={() => dispatchFilter({ type: "MANUAL" })}
        >
          수동 등록
        </div>
      </div>
      <div className="px-5 py-4">
        <div>
          <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
            상품정보
          </div>
          <div className="flex w-full">
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
              >
                카테고리
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
                {productData?.productGroup?.productGroupCategory?.name}
              </div>
            </div>
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
              >
                REF(상품코드)
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
                {productData?.ref}
              </div>
            </div>
          </div>
          <div className="flex w-full">
            <h1 className="border border-t-0 py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
              상품명
            </h1>
            <div className="flex items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
              {productData?.name}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2 px-5">
        <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
          입고 & 재고정보
        </div>
        <table className="min-w-full">
          <thead>
            <tr className="bg-input-grey text-center">
              <th className="border border-t-0 font-light py-2.5 border-primary-grey">
                [입고수량] 스마트팩토리 연동
              </th>
              <th className="border font-light border-t-0 py-2.5 border-primary-grey">
                [입고수량] 수동 등록
              </th>
              <th className="border font-light border-t-0 border-r-2 border-r border-r-[#cccccc] py-2.5 border-primary-grey">
                [연동] 총 입고수량
              </th>
              <th className="border border-t-0 py-2.5 border-primary-grey">
                현재 재고수량
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border text-center py-2.5">{data?.smartQnt}</td>
              <td className="border text-center py-2.5">{data?.manualQnt}</td>
              <td className="border text-secondary-red font-bold text-center py-2.5 border-r-2 border-r border-r-[#cccccc]">
                {data?.totalStockedQnt}
              </td>
              <td className="border text-center font-bold py-2.5">
                {data?.currentStockQnt}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-6 px-5">
        <LotDataTable
          prodId={prodId}
          lotFilter={lotFilter}
          productData={productData}
          setTriggerCloseDataModal={setTriggerCloseDataModal}
        />
      </div>
    </div>
  );
};

export default DataModal;
